import { Injectable, Inject, DOCUMENT } from '@angular/core';

declare var gtag: Function; // Declare gtag to avoid TypeScript errors

@Injectable({ providedIn: 'root' })
export class GooglAnalyticsService {
	constructor(
		@Inject(DOCUMENT) private document: Document
	) { }

	public init(measurementId: string): void {
		// 1. Inject the Global Site Tag script
		const script = this.document.createElement('script');
		script.async = true;
		script.src = "https://www.googletagmanager.com/gtag/js?id=" + measurementId;
		this.document.head.appendChild(script);

		// 2. Initialize the dataLayer and gtag function
		const inlineScript = this.document.createElement('script');
		inlineScript.innerHTML = `
			window.dataLayer = window.dataLayer || [];
			function gtag(){dataLayer.push(arguments);}
			gtag('js', new Date());
			gtag('config', '${measurementId}');
		`;
		this.document.head.appendChild(inlineScript);
	}

	public trackEvent(eventName: string, params: object) {
		if (typeof gtag !== 'undefined') {
			gtag('event', eventName, params);
		}
	}

	public trackApiCall(url: string, method: string, status: number, duration: number) {
		this.trackEvent('ApiCall', {
			'api_url': url,
			'method': method,
			'status': status,
			'duration_ms': duration
		});
	}
}
